var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    ref: "AICancelDialog",
    staticClass: "ai-cancel-dialog",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("richtext.AICancelModal.cancel_generated_content"),
      primaryAction: {
        label: _vm.$t.__("richtext.AICancelModal.confirm_and_reestablish"),
        action: _vm.handleConfirm
      },
      secondaryActions: [
        {
          label: _vm.$t.__("richtext.AICancelModal.back"),
          action: function() {
            _vm.showModal = false
          }
        }
      ]
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("p", {
              staticClass: "typographies-paragraph-medium-regular",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t.__("richtext.AICancelModal.description", {
                    br: "<br />"
                  })
                )
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }